import { ScrollArea } from "@/components/ui/scroll-area";
import CollapsibleItems from "@/components/customer/ticket/CollapsibleItems";
import { getAttachmentIcon } from "@/lib/utils";

interface Attachment {
  id: string;
  name: string;
  contentType: string;
  size: number;
  summary?: string | null;
}

interface AttachmentsPanelProps {
  attachments: Attachment[];
  onDownload: (attachmentId: string) => void;
}

export default function AttachmentsPanel({
  attachments,
  onDownload,
}: AttachmentsPanelProps) {
  if (attachments.length === 0) {
    return (
      <div className="text-sm text-muted-foreground text-center py-4">
        Keine Anhänge vorhanden
      </div>
    );
  }

  return (
    <ScrollArea className="h-[calc(100vh-200px)]">
      <div className="flex flex-col gap-2 p-1">
        <CollapsibleItems items={attachments} toggleClassName="self-start">
          {(visible) =>
            visible.map((attachment) => (
              <div
                key={attachment.id}
                className="flex flex-col gap-1 p-2 rounded-md bg-secondary text-sm cursor-pointer hover:bg-secondary/80"
                onClick={() => onDownload(attachment.id)}
                title={attachment.name}
              >
                <div className="flex items-center gap-2">
                  {getAttachmentIcon(attachment.contentType)}
                  <span className="flex-1 truncate">{attachment.name}</span>
                  <span className="text-muted-foreground whitespace-nowrap">
                    (
                    {attachment.size < 1024
                      ? `${attachment.size}B`
                      : attachment.size < 1024 * 1024
                        ? `${Math.round(attachment.size / 1024)}KB`
                        : `${Math.round(attachment.size / (1024 * 1024))}MB`}
                    )
                  </span>
                </div>
                {attachment.summary && (
                  <p className="text-muted-foreground text-sm pl-6">
                    {attachment.summary}
                  </p>
                )}
              </div>
            ))
          }
        </CollapsibleItems>
      </div>
    </ScrollArea>
  );
}
